import React, { useState, useEffect } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import moment from "moment";
import $ from "jquery";
import "daterangepicker/daterangepicker.css";
import "daterangepicker";
import { CSVLink } from "react-csv";


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


const ViewCount = () => {
 const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
    const [district, setDistrict] = useState("all");
    const [type, setType] = useState("all");
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchData();
    }, [startDate, endDate, district, type]);


                                                                                                                        
                                                  useEffect(() => {
                                                    document.title = 'View Count - Calendar Services';
                                                
                                                    // Initialize the date range picker
                                                    $("#kt_daterangepicker_4").daterangepicker(
                                                      {
                                                        startDate: moment(),
                                                        endDate: moment(),
                                                        ranges: {
                                                          Today: [moment(), moment()],
                                                          Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
                                                          "Last 7 Days": [moment().subtract(6, "days"), moment()],
                                                          "Last 30 Days": [moment().subtract(29, "days"), moment()],
                                                          "This Month": [moment().startOf("month"), moment().endOf("month")],
                                                          "Last Month": [moment().subtract(1, "month").startOf("month"), moment().subtract(1, "month").endOf("month")],
                                                        },
                                                      },
                                                      (start, end) => {
                                                        setStartDate(start.format("YYYY-MM-DD"));
                                                        setEndDate(end.format("YYYY-MM-DD"));
                                                        $("#kt_daterangepicker_4").html(`${start.format("MMMM D, YYYY")} - ${end.format("MMMM D, YYYY")}`);
                                                      }
                                                    );
                                                
                                                    // Set initial display value
                                                    $("#kt_daterangepicker_4").html(
                                                      `${moment().format("MMMM D, YYYY")} - ${moment().format("MMMM D, YYYY")}`
                                                    );
                                                  }, []);
                                        

    const fetchData = async () => {
        setLoading(true);
        try {
            // const response = await axios.post("http://localhost:3036/viewcount", {
                const response = await axios.post(`${API_BASE_URL}/viewcount`, {

                startDate,
                endDate,
                district,
                type,
            });
            setData(response.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    const columns = [
        { name: "SlNo", selector: (_, index) => index + 1, sortable: true },
        { name: "Name", selector: (row) => row.name, sortable: true },
        { name: "Mobile No", selector: (row) => row.mobileno, sortable: true },
        {
            name: "Type",
            selector: (row) => row.type,
            cell: (row) => (
                <span
                    style={{
                        background: row.typeColor,
                        padding: "5px",
                        color: "#fff",
                        borderRadius: "3px",
                    }}
                >
                    {row.type}
                </span>
            ),
            sortable: true,
        },
        { name: "Date",          
               selector: (row) => new Date(row.date).toLocaleDateString("en-GB"), 
            
            sortable: true },
        { name: "View Count", selector: (row) => row.view_count, sortable: true },
        { name: "Call Count", selector: (row) => row.call_count, sortable: true },
        // { name: "Last Update", selector: (row) => row.last_update, sortable: true },
          { 
                    name: "Last Update", 
                    selector: (row) => moment(row.last_update).format("DD-MM-YYYY HH:mm:ss"), 
                    sortable: true 
                },
                { name: "cby", selector: (row) => row.cby, sortable: true },

    ];



    const csvHeaders = [
        { label: "SlNo", key: "slno" },
        { label: "Name", key: "name" },
        { label: "Mobile No", key: "mobileno" },
        { label: "Type", key: "type" },
        { label: "Date", key: "date" },
        { label: "View Count", key: "view_count" },
        { label: "Call Count", key: "call_count" },
        { label: "Last Update", key: "last_update" },
    ];
    

    
    

    return (
        <div className="max-w-6xl mx-auto mt-8 bg-white">
            <h2 className="text-2xl font-bold mb-6 text-center">View Count Report</h2>
               <div className="flex justify-center items-center gap-2 mb-6">
                                                                <div className="mb-3">
                                                                                                <div className="text-center mb-6 flex items-center space-x-2 justify-center">
                                                                                                  <div id="kt_daterangepicker_4" className="bg-white border px-4 py-2 inline-block rounded cursor-pointer">
                                                                                                    {`${moment().format("MMMM D, YYYY")} - ${moment().format("MMMM D, YYYY")}`}
                                                                                                  </div>
                                                                                    
                                                                                                  <svg
                                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                                    className="h-5 w-5 text-gray-500"
                                                                                                    fill="none"
                                                                                                    viewBox="0 0 24 24"
                                                                                                    stroke="currentColor"
                                                                                                  >
                                                                                                    <path
                                                                                                      strokeLinecap="round"
                                                                                                      strokeLinejoin="round"
                                                                                                      strokeWidth={2}
                                                                                                      d="M8 7V3m8 4V3m-6 4h6m4 0a2 2 0 012 2v10a2 2 0 01-2 2H6a2 2 0 01-2-2V9a2 2 0 012-2h12z"
                                                                                                    />
                                                                                                  </svg>
                                                                                                </div>
                                                                                              </div>
                                                                                              </div>
                                                                                              
                                                                                              <div className="flex justify-center items-center gap-6 mb-6">
                                                                <div className="flex flex-col items-center">
                                                                    <label htmlFor="district" className="mb-1 font-medium">
                                                                        District:
                                                                    </label>
                                                                    <select
                                                                        id="district"
                                                                        value={district}
                                                                        onChange={(e) => setDistrict(e.target.value)}
                                                                        className="border border-gray-300 rounded-md p-2"
                                                                    >
                                                                        <option value="all">மாவட்டத்தை தேர்வு செய்க</option>
                                                        <option value="அரியலூர்">அரியலூர்</option>
                                                        <option value="இராமநாதபுரம்">இராமநாதபுரம்</option>
                                                        <option value="ஈரோடு">ஈரோடு</option>
                                                        <option value="கடலூர்">கடலூர்</option>
                                                        <option value="கன்னியாகுமரி">கன்னியாகுமரி</option>
                                                        <option value="கரூர்">கரூர்</option>
                                                        <option value="கள்ளக்குறிச்சி">கள்ளக்குறிச்சி</option>
                                                        <option value="காஞ்சிபுரம்">காஞ்சிபுரம்</option>
                                                        <option value="காரைக்கால்">காரைக்கால்</option>
                                                        <option value="கிருஷ்ணகிரி">கிருஷ்ணகிரி</option>
                                                        <option value="கோயம்புத்தூர்">கோயம்புத்தூர்</option>
                                                        <option value="சிவகங்கை">சிவகங்கை</option>
                                                        <option value="செங்கல்பட்டு">செங்கல்பட்டு</option>
                                                        <option value="சென்னை">சென்னை</option>
                                                        <option value="சேலம்">சேலம்</option>
                                                        <option value="தஞ்சாவூர்">தஞ்சாவூர்</option>
                                                        <option value="தர்மபுரி">தர்மபுரி</option>
                                                        <option value="திண்டுக்கல்">திண்டுக்கல்</option>
                                                        <option value="திருச்சிராப்பள்ளி">திருச்சிராப்பள்ளி</option>
                                                        <option value="திருநெல்வேலி">திருநெல்வேலி</option>
                                                        <option value="திருப்பத்தூர்">திருப்பத்தூர்</option>
                                                        <option value="திருப்பூர்">திருப்பூர்</option>
                                                        <option value="திருவண்ணாமலை">திருவண்ணாமலை</option>
                                                        <option value="திருவள்ளூர்">திருவள்ளூர்</option>
                                                        <option value="திருவாரூர்">திருவாரூர்</option>
                                                        <option value="தூத்துக்குடி">தூத்துக்குடி</option>
                                                        <option value="தென்காசி">தென்காசி</option>
                                                        <option value="தேனி">தேனி</option>
                                                        <option value="நாகப்பட்டினம்">நாகப்பட்டினம்</option>
                                                        <option value="நாமக்கல்">நாமக்கல்</option>
                                                        <option value="நீலகிரி">நீலகிரி</option>
                                                        <option value="புதுக்கோட்டை">புதுக்கோட்டை</option>
                                                        <option value="புதுச்சேரி">புதுச்சேரி</option>
                                                        <option value="பெரம்பலூர்">பெரம்பலூர்</option>
                                                        <option value="மதுரை">மதுரை</option>
                                                        <option value="மயிலாடுதுறை">மயிலாடுதுறை</option>
                                                        <option value="மஹி">மஹி</option>
                                                        <option value="யானம்">யானம்</option>
                                                        <option value="ராணிப்பேட்டை">ராணிப்பேட்டை</option>
                                                        <option value="விருதுநகர்">விருதுநகர்</option>
                                                        <option value="விழுப்புரம்">விழுப்புரம்</option>
                                                        <option value="வேலூர்">வேலூர்</option>
                                                                            </select>
                                                                </div>
                                                                <div className="flex flex-col items-center">
                                                                    <label htmlFor="type" className="mb-1 font-medium">
                                                                    Type:
                                                                    </label>
                                                                    <select
                                                                        id="type"
                                                                        value={type}
                                                                        onChange={(e) => setType(e.target.value)}
                                                                        className="border border-gray-300 rounded-md p-2"
                                                                    >
                                                                        <option value="all">வகையை தேர்வு செய்க</option>
                                                                        <option value="வாஸ்து நிபுணர்">வாஸ்து நிபுணர்</option>
                                                                        <option value="மற்ற ஆன்மிக சேவைகள்">மற்ற ஆன்மிக சேவைகள்</option>
                                                                        <option value="ஜோதிடர்">ஜோதிடர்</option>
                                                                        <option value="ஐயர்">ஐயர்</option>
                                                                        <option value="எண்கணிதம்">எண்கணிதம்</option>
                                                                        <option value="அலங்காரம் செய்பவர்others">அலங்காரம் செய்பவர்others</option>
                                                                        <option value="சிற்பி / ஸ்தபதி- others">சிற்பி / ஸ்தபதி- others</option>
                                                                        <option value="others">others</option>
                                                                        <option value="ஆன்மீக சொற்பொழிவாளர்- others">ஆன்மீக சொற்பொழிவாளர்- others</option>
                                                                        <option value="விபூதி தயாரிப்பவர்- others">விபூதி தயாரிப்பவர்- others</option>
                                                                        <option value="சிர்பி-others">சிர்பி-others</option>
                                                                        <option value="திருவிழா அலங்காரம் செய்பவர்- others">திருவிழா அலங்காரம் செய்பவர்- others</option>
                                                                    </select>
                                                                </div>
                                                            </div>
       
       
                      <div className="flex justify-end mb-5">
                                                           <CSVLink
                                                               data={data}
                                                               headers={csvHeaders}
                                                               filename="Expire_search_list.csv"
                                                               className="bg-green-500 text-white px-4 py-2 rounded-md"
                                                           >
                                                               Export to Excel
                                                           </CSVLink>
                                                       </div>
            <DataTable
                columns={columns}
                data={data}
                progressPending={loading}
                pagination
                highlightOnHover
            />
        </div>
    );
};

export default ViewCount;
